import React from 'react'
export default function TarjetaContenido({
  titulo,
  children,
  component = null,
}) {
  return (
    <div className='card shadow mb-4'>
      <div
        className='d-flex justify-content-between card-header align-items-center py-3'
        role='button'
      >
        <h6 className='m-0 font-weight-bold' style={{ color: '#004669' }}>
          {titulo}
        </h6>

        {component}
      </div>
      <div>
        <div className='card-body'>{children}</div>
      </div>
    </div>
  )
}
